import {
  getConfirmingStatusChipType,
  getStatusChipColor,
} from 'lib/mobileDesignSystem';
import React, { createContext, useCallback, useContext, useState } from 'react';

export interface ConfirmingOperationDetailContextValue {
  status: string | null;
  setOperationStatus: (status: string | null) => void;
  requestId: string | null;
  setRequestId: (id: string | null) => void;
}

const ConfirmingOperationDetailContext =
  createContext<ConfirmingOperationDetailContextValue | null>(null);

export const useConfirmingOperationDetail =
  (): ConfirmingOperationDetailContextValue => {
    const ctx = useContext(ConfirmingOperationDetailContext);
    if (ctx == null) {
      throw new Error(
        'useConfirmingOperationDetail must be used within ConfirmingOperationDetailProvider',
      );
    }
    return ctx;
  };

export const getConfirmingStatusColor = (status: string): string => {
  const type = getConfirmingStatusChipType(status);
  return getStatusChipColor(type);
};

export const ConfirmingOperationDetailProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [status, setOperationStatus] = useState<string | null>(null);
  const [requestId, setRequestId] = useState<string | null>(null);

  const value: ConfirmingOperationDetailContextValue = {
    status,
    setOperationStatus: useCallback((s) => setOperationStatus(s), []),
    requestId,
    setRequestId: useCallback((id) => setRequestId(id), []),
  };

  return (
    <ConfirmingOperationDetailContext.Provider value={value}>
      {children}
    </ConfirmingOperationDetailContext.Provider>
  );
};
